// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"183b3dc1","345":"183b3dc1","501":"e022ef41","506":"1ddd05a4","529":"53e52850","677":"de8e0854"}[chunkId] + ".chunk.css";
};